import { useQuery } from '@tanstack/react-query';

import { getRetryDelay, shouldRetryRequest } from '@/shared/lib/query/retryConfig';

import { getExperimentRuns } from '@/entities/experiment/api';
import type { ExperimentRunsResponse } from '@/entities/experiment/domain/types';

export const EXPERIMENT_RUNS_QUERY_KEY = 'experiment-runs';

/**
 * 실험별 런 목록 조회 훅
 * 실험 확장 시 사용
 */
export const useExperimentRuns = (experimentId: string, enabled = true) => {
  return useQuery<ExperimentRunsResponse>({
    queryKey: [EXPERIMENT_RUNS_QUERY_KEY, experimentId],
    queryFn: () => getExperimentRuns(experimentId),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: shouldRetryRequest,
    retryDelay: getRetryDelay,
  });
};
